// Shared by every page that links to a product (category page, subcategory
// page, related products) so the "which URL does this product live at"
// logic exists exactly once.

// Identical algorithm to Shingare-Backend/utils/helpers.js's slugify, so
// client-side fallback matching (for products not yet re-saved with a
// persisted *_slug field) agrees with what the server would compute.
export function slugify(text) {
  return (text || "")
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/[-\s]+/g, "-");
}

// A product's subcategory slug: the persisted value if the product has been
// saved since the backend started attaching it, otherwise derived on the
// fly from the free-text `subcategory` field.
export function productSubcategorySlug(product) {
  if (!product) return "";
  return product.subcategory_slug || (product.subcategory ? slugify(product.subcategory) : "");
}

// Canonical link for a product card. Uses the full
// /products/:category/:subcategory/:slug path when both are resolvable;
// otherwise falls back to the flat /products/:slug (still fully valid —
// ProductOrCategoryResolver serves it). There is no 2-segment
// "category+product" URL — that shape is already used for
// "category+subcategory".
export function productHref(product) {
  if (!product) return "/products";
  const categorySlug = product.category_slug || (product.category ? slugify(product.category) : "");
  const subcategorySlug = productSubcategorySlug(product);
  if (categorySlug && subcategorySlug) {
    return `/products/${categorySlug}/${subcategorySlug}/${product.slug}`;
  }
  return `/products/${product.slug}`;
}
